import { ErrorTextCoreProps } from "./types"
import React from "react"
import styled from '~/ui/styled'
import Icon from "~widgets/icon"

const ErrorWrap = styled.View`
  flex-direction: row;
  align-items: center;
  margin-top: ${({ theme }) => theme.space.xs};
`
const Text = styled.Text`
  margin: ${({ theme }) => theme.space.xs} 0;
  font-size: ${({ theme }) => theme.fontSizes.sm};
  color: #ff0000;
  margin-left: 3px;
`

export const ErrorTextCore: React.FC<ErrorTextCoreProps> = ({ text }) => {
  return (
    <ErrorWrap>
      <Icon name="warning" color="#FF0000" size={14} />
      <Text>{text}</Text>
    </ErrorWrap>
  )
}
export default ErrorTextCore
